var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ChatText"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.09375 15.9346L3.52344 18.0908C3.43238 18.1662 3.32183 18.2142 3.20461 18.2292C3.08738 18.2443 2.96829 18.2258 2.86115 18.1759C2.75401 18.126 2.66321 18.0468 2.59929 17.9473C2.53536 17.8479 2.50094 17.7324 2.5 17.6143V5.20801C2.5 5.04225 2.56585 4.88328 2.68306 4.76607C2.80027 4.64886 2.95924 4.58301 3.125 4.58301H16.875C17.0408 4.58301 17.1997 4.64886 17.3169 4.76607C17.4342 4.88328 17.5 5.04225 17.5 5.20801V15.208C17.5 15.3738 17.4342 15.5327 17.3169 15.65C17.1997 15.7672 17.0408 15.833 16.875 15.833H6.38281L6.09375 15.9346Z",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.5 8.95801H12.5",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.5 11.458H12.5",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.767c0ee12d548697165b04dec64fdd80.svg";
export { ForwardRef as ReactComponent };